import { render } from "./UsersTable.vue?vue&type=template&id=9bd3f37c&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"

import "./UsersTable.vue?vue&type=style&index=0&id=9bd3f37c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd3f37c"]])

export default __exports__